import { AlertIcon, Banner, InfoIcon } from '@iheartjane/reefer';

import type { ExclusionOverlap } from './conditions.types';

interface ExclusionOverlapBannerProps {
  /** The section's label, ex "Brands" */
  label: string;
  overlap: ExclusionOverlap;
}

/** Explains how a section's legacy exclusions were simplified on load */
export const ExclusionOverlapBanner = ({
  label,
  overlap,
}: ExclusionOverlapBannerProps) => {
  const name = label.toLowerCase();

  if (overlap === 'conflicting') {
    return (
      <Banner
        full
        variant="error"
        icon={<AlertIcon />}
        label={`This group excluded all of the ${name} it included, so it matched no products. We've removed the excluded ${name}, so review the included ${name} before saving.`}
      />
    );
  }

  return (
    <Banner
      full
      variant="info"
      icon={<InfoIcon />}
      label={`We've simplified how this group includes and excludes ${name}. It still matches the same products.`}
    />
  );
};
